
// import React from 'react';
// import ReactDOM from 'react-dom';
// import store from './store';
// import './css/index.css';
// import Root from './containers/root';
// import * as serviceWorker from './serviceWorker';
// import { Provider } from 'react-redux'

// ReactDOM.render(
//     <Provider store={store}><Root /></Provider>, document.getElementById('root')
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();







import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store"; // Ensure correct import
import './css/index.css';
import Root from "./containers/root"; // Ensure correct import

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <Root />
    </Provider>
);






